/*
 ###############################################################################
 #                                                                             #
 # File Created: 2021-07-28 13:33:46                                           #
 #                                                                             #
 # Author: zhuxiaomin                                                          #
 #                                                                             #
 # Description:                                                                #
 #                                                                             #
 # Copyright (c) 2021 designorder.cn                                           #
 #                                                                             #
 ###############################################################################
 */

const TOKEN = 'token';

export function getToken(): string {
    return localStorage.getItem(TOKEN) ?? '';
}

export function setToken(token: string): void {
    localStorage.setItem(TOKEN, token);
}
